export default __webpack_public_path__ + "static/media/cake.2acb6847.png";